<template>
  <div class="flex justify-end items-center my-2">
    <button
      v-show="showButton"
      :disabled="isDisabled"
      class="rounded-md bg-primary/80 hover:bg-primary flex items-center hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
      @click.prevent="onClick"
    >
      <div v-if="icon" class="flex justify-center items-center h-full bg-black/10 p-2 rounded-s">
        <FontAwesomeIcon :icon="fontAwesomeIcon()" class="w-3 text-white" />
      </div>
      <span class="px-1.5 ltr:font-sans tracking-wide text-white text-sm pb-[1px]">
        {{ $t(props.text) }}
      </span>
    </button>
    <span v-if="type == 'otp' && otpCount > 0"
      >{{ $t('otpParagraph') }} {{ otpCount }} {{ $t('second') }}</span
    >
  </div>
</template>

<script setup>
import useButtonActions from '@/composables/actions/useButtonActions'
import useVisible from '@/composables/useVisible'
import { faSearch, faInfoCircle, faIdCard, faAdd } from '@fortawesome/free-solid-svg-icons'
import { notify } from 'notiwind'
import { computed, watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import useCountdown from '@/composables/useCountdown'

const props = defineProps({
  type: String,
  otpConfig: Object,
  // general props
  icon: {
    type: String,
    required: ''
  },
  text: {
    type: String,
    required: ''
  },
  on_click: {
    type: Object
  },
  disabled: [Boolean, Object]
})

const route = useRoute()
const i18n = useI18n()
const { findShowRule, getBindObj } = useVisible()

const { time: otpCount, start: startOtp } = useCountdown()

watchEffect(() => {
  getBindObj(route.params.serviceId)
})

const isDisabled = computed(() => {
  if (typeof props.disabled === 'boolean') {
    return props.disabled
  }

  if (Object.keys(props.disabled).length > 0) {
    const result = findShowRule(
      props.disabled.any || props.disabled.all,
      props.disabled.any ? 'any' : 'all',
      getBindObj(route.params.serviceId)
    )

    return !result
  }

  return false
})

const showButton = computed(() => {
  if (props?.type === 'otp') {
    return otpCount.value == 0
  }
  return true
})

const fontAwesomeIcon = () => {
  switch (props.icon) {
    case 'faSearch':
      return faSearch
    case 'faAdd':
      return faAdd
    case 'faInfoCircle':
      return faInfoCircle
    case 'faIdCard':
      return faIdCard
    default:
      return null
  }
}

const onClick = async () => {
  if (!props.on_click?.action) return

  try {
    await useButtonActions()[props.on_click.action]()
    if (props.type === 'otp') {
      startOtp(props.otpConfig.countDown)
    }
  } catch (error) {
    notify(
      {
        group: 'error',
        title: i18n.t('errorSetDefaultAddress'),
        text: i18n.t(error.toString())
      },
      6000
    )
  }
}
</script>

<style lang="scss" scoped></style>
